
import Vue from "vue";
import { 
  mapActions,
  mapGetters,
  mapMutations
} from "vuex";
import axios from "axios";
import Wraxios from "./../../services/Wraxios";
import { logUserOut } from "./../../services/SharedFunctions";

const wraxios = new Wraxios();

export default Vue.extend ({
  data() {
    return {
      drawer: false,
      items: [] as {
        title: string;
        icon: string;
        onClick: Function;
      }[],
    };
  },
  props: {
    languages: { type: Array, required: true },
    title: { type: String, required: true }
  },
  computed: {
    ...mapGetters({
      getUserSessionHash: "get_userSessionHash",
      getUserIsAuthenticated: "get_userIsAuthenticated",
      translations: "get_translations",
      language: "get_language"
    })
  },
  beforeMount() {
    this.items = [
        { title: "Home", icon: "mdi-home", onClick: this.goHome },
        { title: "Logout", icon: "mdi-logout", onClick: this.logout }
    ];
  },
  methods: {
    ...mapActions({
      setSessionHash: "do_setSessionHash",
      setUserIsAuthenticated: "do_setUserIsAuthenticated",
      showToast: "do_showSnackbar"
    }),
    ...mapMutations({
      setLanguage: "set_language",
      showOverlay: "set_showOverlay"
    }),
    async logout() {
      logUserOut(this.$router, false);
    },
    async switchLanguage(language: string) {  
      this.showOverlay(true);
      
      if (this.language !== language) {
        this.setLanguage(language);
        const payload = {language: language};

        await wraxios.post(
          axios,
          `/account/translations?language=${language}`,
          payload,
          {}
        );

        this.$router.go(0);
      }
    },
    goHome() {
      if (this.$route.name === "LandingPage") {
        return;
      }
      
      this.showOverlay(true);      
      this.$router.push("/LandingPage");
    }
  }
});
